import { Controller } from "@hotwired/stimulus";
import { onCustomizationRendered } from "./event";

class BaseCustomization extends Controller {
  initialize() {
    this.tabItem = "";
  }

  connect() {
    this.isPersisted = !!document.body.dataset.siteBuilderSite;
    if (this.isPersisted) {
      this.persistenceController =
        this.application.getControllerForElementAndIdentifier(
          document.querySelector(".ctas"),
          "site-builder--persistence"
        );
      this.hideReset();
    }
    onCustomizationRendered(() => {
      /*
          This makes sure that the iframe is available before you can see the default selections
       */
      this.initializeSelection();
    });
  }

  initializeSelection() {}

  fetchFromPreview() {}

  fetchFromStore() {}

  values() {
    return this.isPersisted ? this.fetchFromPreview() : this.fetchFromStore();
  }

  isCustomizationSame(selected) {
    const current = this.element.querySelector(".selected");
    if (!current) return false;

    return (
      current.dataset[this.customizationType] ===
      selected.dataset[this.customizationType]
    );
  }

  removeSelectedOption() {
    this.selectionTargets.forEach((selection) => {
      selection.classList.remove("selected");
    });
  }

  highlightTabSelection() {
    this.tabItem?.classList?.add?.("has-customization");
  }

  removeTabSelection() {
    this.tabItem?.classList?.remove?.("has-customization");
  }

  hideReset() {
    if (this.isPersisted) {
      this.resetTarget?.classList?.add?.("hidden");
      this.persistenceController.updateButtonState();
    }
  }

  showReset() {
    if (this.isPersisted) {
      this.resetTarget?.classList?.remove?.("hidden");
      this.persistenceController.updateButtonState();
    }
  }
}

export default BaseCustomization;
